import { Stack, StackProps } from '@mantine/core';
import { RawModel } from '@/types/rawModel';
import { CollapsibleSection } from '@/app/components/shared/viewer/CollapsibleSection';
import { NameValuePair } from './NameValuePair';

type RawModelMetadataProps = { asset: RawModel } & StackProps;

export const RawModelMetadata = ({
  asset,
  ...stackProps
}: RawModelMetadataProps) => {
  if (!asset.metadata) {
    return null;
  }

  const metadataArray = Object.entries(asset.metadata.data).flatMap(
    ([key, value]) => {
      if (Array.isArray(value)) {
        return value.flatMap((item) => Object.entries(item));
      }
      return [[key, value]];
    }
  );

  return (
    <CollapsibleSection title='Metadata'>
      <Stack gap='4' {...stackProps}>
        {metadataArray.map(([key, value]) => (
          <NameValuePair key={key} name={key} value={JSON.stringify(value)} />
        ))}
      </Stack>
    </CollapsibleSection>
  );
};
